/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductDetails {
    getFixupPrototypeFunction() { return ProductDetails.fixupPrototype; }

    static newInstance(model: Partial<ProductDetails>): ProductDetails {
        let obj = Object.assign(new ProductDetails(), model);
        ProductDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductDetails>): ProductDetails {
        if (!model) return null;
        return ProductDetails.newInstance(<ProductDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductDetails) {
        if (!obj) return;

        models.ProductDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductDetails): boolean {
        Object.setPrototypeOf(obj, ProductDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the product
     */
    name: models.ProductEnum;

    /**
     * Description of the product
     */
    description: string;

    features: Array<models.ServiceAccountFeature>;

    /**
     * Role templates mapped for the product
     */
    role_templates: Array<string>;

}
